import "./App.css";
import Routes from "./components/routes/Routes";
import { useEffect, useState } from "react";

function App() {
  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;
